__webpack_require__.p = "https://static.small-improvements.com/static/";